import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';

const fetchCreatePpeVesselGroup = (data) => {
    return axios.post(apiurl?.createPpeVesselGroup, data);
  };
const createPpeVesselGroup = () => {
  const queryClient = useQueryClient();
  return useMutation(fetchCreatePpeVesselGroup, {
    onSuccess: () => {
      showAlert('Vessel Group Created Successfully!', 'success');
      queryClient.invalidateQueries('getPpeVesselGroup');
    },
    onError: (error) => {
      showAlert(error?.response?.data, 'error');
    }
  });
};

export default createPpeVesselGroup;
